/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type {Request_ResultPush} from "../types/push-messages.js";
// Type-only imports: the backend + root barrels of these packages pull
// firebase-admin/fs into the bundle when imported as values.
import type {ExpressRequest} from "@intuitionrobotics/thunderstorm/backend";
import type {UI_Account} from "@intuitionrobotics/user-account/shared/api";

export const Permissions_ProductOwner = {_id: "product-owner", key: "Product", label: "Owner"};
export const Permissions_ProductEditor = {_id: "product-editor", key: "Product", label: "Editor"};
export const Permissions_ProductViewer = {_id: "product-viewer", key: "Product", label: "Viewer"};
export const PermissionProductGroups = [Permissions_ProductOwner,
    Permissions_ProductEditor,
    Permissions_ProductViewer];


export interface OnPushResult {
    __onPushResult(request: ExpressRequest, body: Request_ResultPush): Promise<void>;
}

export interface OnSessionValidated {
    __onSessionValidated: (account: UI_Account) => Promise<void>;
}

export interface OnAccountAdded {
    __onAccountAdded: (account: UI_Account) => Promise<void>;
}

export const Elliq_ProductKey = 'elliq';
